import { useSearchParams } from "react-router-dom";

import EmailListStructure from "../EmailComponents/EmailListTabContents/EmailListStructure";
import RenderEmailTabs from "../RenderEmailTabs";
import LabelsList from "./LabelsList/LabelsList";

export default function Inbox({ activeTab, setActiveTab }) {
  /*   All States
   ********************************************* */
  const [searchParams] = useSearchParams();

  const authorized = searchParams.get("auth") === "required" ? false : true;

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <div className="inbox-root d-flex" style={{ height: "100vh" }}>
      {authorized ?
        <>
          <aside
            className="bg-white border-end"
            style={{ minWidth: 300, width: "300px" }}
          >
            <div className="p-2">
              <RenderEmailTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>

            <LabelsList />
          </aside>
          <EmailListStructure />
        </>
      : <div className="d-flex justify-content-center align-items-center w-100">
          <div className="card rounded-3 p-3" style={{ maxWidth: 500 }}>
            <div className="card-body text-center">
              <h2 className="card-title mb-3">Authorization Required</h2>
              <p className="card-text">
                Please authorize your email account to access your inbox.
                <p className="mt-1">
                  Go to <b>Settings &gt; Email Clients</b> to connect your email
                  account.
                </p>
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
